import { Component, OnDestroy, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { environment } from 'src/environments/environment';

import { Document } from 'src/app/shared/document';

@Component({
  selector: 'app-new-document-dlg-conditions',
  templateUrl: './new-document-dlg-conditions.component.html',
  styleUrls: ['./new-document-dlg-conditions.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class NewDocumentDlgConditionsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() condLable: string = 'Условия поставки';
  @Input() sNoteLable: string = 'Примечание для продавца';
  @Input() bNoteLable: string = 'Примечание для покупателя';

  @Input() parentDocument: Document;

  @Input() newDocument: Document;

  public get hasParentDocument(): boolean { return (this.parentDocumentId && true); }

  parentDocumentId: number;

  //deliveryConditions: any[] = [
  //  { name: 'Отгрузка и оплата', code: 0 },
  //  { name: 'Предоплата', code: 1 },
  //  { name: 'Отсрочка', code: 2 },
  //  { name: 'Доставка до склада', code: 3 },
  //  { name: 'Самовывоз', code: 4 },
  //  { name: 'Опция 3', code: 5 },
  //  { name: 'Опция 100', code: 6 }
  //];

  deliveryConditions: string[] = [
    'Отгрузка и оплата',
    'Предоплата',
    'Отсрочка',
    'Доставка до склада',
    'Самовывоз',
    'Опция 3',
    'Опция 100',
  ];

  deliveryConditionsResult: string[];
  suggestDeliveryConditions: string[];

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** NewDocumentDlgConditionsComponent ngOnChanges:');
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** NewDocumentDlgConditionsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** NewDocumentDlgConditionsComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {

        case 'parentDocument':
          break;
      }
    }
  }

  ngOnDestroy(): void {
    console.log('*** NewDocumentDlgConditionsComponent in ngOnDestroy')

  }

  ngOnInit(): void {
    console.log('*** NewDocumentDlgConditionsComponent in ngOnInit');

  }

  searchDeliveryOptions(event) {
    console.log('*** NewDocumentDlgConditionsComponent searchDeliveryOptions  ' + JSON.stringify(event));

    this.suggestDeliveryConditions = this.deliveryConditions.filter(e => e.includes(event.query)) || [];
  }

  onSelectDeliveryOptions(event) {
    console.log('*** NewDocumentDlgConditionsComponent onSelectDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.newDocument.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.newDocument.DOCDLVBASE += ', ' + e; })
      console.log(this.newDocument.DOCDLVBASE);
    }
  }

  onUnselectDeliveryOptions(event) {
    console.log('*** NewDocumentDlgConditionsComponent onUnselectDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.newDocument.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.newDocument.DOCDLVBASE += ', ' + e; })
      console.log(this.newDocument.DOCDLVBASE);
    }
  }

  onDropdownClickDeliveryOptions(event) {
    console.log('*** NewDocumentDlgConditionsComponent onDropdownClickDeliveryOptions  ' + JSON.stringify(event));
    this.suggestDeliveryConditions = [... this.deliveryConditions];
    environment.production || console.table(this.deliveryConditionsResult);

    //  if (this.deliveryConditionsResult) {
    //    this.newDocument.DOCDLVBASE = '';
    //    this.deliveryConditionsResult.forEach(e => { this.newDocument.DOCDLVBASE += ', ' + e; })
    //    console.log(this.newDocument.DOCDLVBASE);
    //  }
  }

  onClearDeliveryOptions(event) {
    console.log('*** NewDocumentDlgConditionsComponent onClearDeliveryOptions  ' + JSON.stringify(event));
    environment.production || console.table(this.deliveryConditionsResult);

    if (this.deliveryConditionsResult) {
      this.newDocument.DOCDLVBASE = '';
      this.deliveryConditionsResult.forEach(e => { this.newDocument.DOCDLVBASE += ', ' + e; })
      console.log(this.newDocument.DOCDLVBASE);
    }
  }

}
